import moment from 'moment';
import { Minutes } from 'type';

export function formatMinutesToTime(minutes: Minutes, timeFormat: string) {
  return moment().startOf('day').add(minutes, 'minutes').format(timeFormat);
}
